export default __webpack_public_path__ + "static/general-fund-group-2918e8fcc05a763d9958c3afe9e31864.png";